import { Theme } from '@mui/material/styles'
import { SystemStyleObject } from '@mui/system'

export const thinScrollbarSx: SystemStyleObject<Theme> = {
    '&::-webkit-scrollbar': { width: '4px', height: '4px' },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'figma.grayscale.tier6',
        borderRadius: '4px',
        '&:hover': { backgroundColor: 'figma.grayscale.tier5' },
    },
}
